<template>
  <div class="sect-section">
    <div class="container">
      <h1 class="sect-title">Seitas</h1>
      <p class="lead text-center mb-4" style="color: #e9ecef;">
        Conheça Camarilla, Sabbat, Anarquistas e seitas independentes para enriquecer a ficha de vampiro, alinhar clãs e
        planejar crônicas de Vampiro A Máscara com foco em Jyhad e disputas políticas.
      </p>
      <div class="row">
        <div
          v-for="sect in sectList"
          :key="sect.id"
          class="col-md-6 mb-4"
        >
          <div class="card clan-card h-100">
            <div class="card-body d-flex flex-column">
              <h5 class="card-title">{{ sect.name }}</h5>
              <p class="card-text flex-grow-1">{{ sect.summary }}</p>
              <div class="d-flex gap-2 mt-2">
                <button class="btn btn-vampire" @click="$emit('open-info', sect.id)">
                  <i class="bi bi-info-circle me-2"></i>
                  Informações
                </button>
                <button class="btn btn-secondary" style="background: var(--vampire-light-gray); border: 1px solid var(--vampire-red); color: #f8f9fa;" @click="$emit('open-clans', sect.id)">
                  <i class="bi bi-people-fill me-2"></i>
                  Ver Clãs
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sectsData } from '../data/sects.js'

export default {
  name: 'SectsIndexView',
  computed: {
    sectList() {
      return Object.keys(sectsData).map(id => ({ id, name: sectsData[id].name, summary: sectsData[id].summary }))
    }
  }
}
</script>

<style scoped>
</style>

